// Función helper para convertir strings a boolean
export const parseBoolean = (value: string | undefined, defaultValue = false): boolean => {
  if (value === undefined) return defaultValue;
  return value === 'true';
};
